import { useQuery } from '@tanstack/react-query';

export default useQuery;
